import { useScheduleV2QueryUpdaters } from '../query-updaters';

export const useScheduleV2InvalidateQueries = () => {
  const { invalidateQueries } = useScheduleV2QueryUpdaters();

  const invalidateQuickFillCount = (locationId?: string) =>
    invalidateQueries({
      endpointName: 'Count',
      queryFilters: {
        exact: false,
        predicate: ({ queryKey }) => {
          const request = queryKey[2];
          return (request.locationIds ?? []).includes(locationId || '');
        },
      },
    });

  return {
    invalidateQuickFillCount,
  };
};
